//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';
import { Dialog } from 'element-ui';
import QR from 'qrcode.vue';
import * as types from '@/types';
import commentTextarea from '@/components/public/comment/comment-textarea.vue';
import MessageDialog from '@/components/public/violation/message-dialog.vue';
import { sendDynamic } from '@/api/index';
import { shareItem } from '@/api/hotpost';
import { linkPage } from '~/utils/util';
import {
  setDynamicLike,
  deleteDynamicLike,
  likePost,
  cancelLikePost,
  setCommentLike,
  deleteCommentLike,
} from '~/api/index';
import { GetShareAbleMoments } from '@/api/moments';
import { formartRoute } from '@/utils/util';

export default {
  name: 'ItemShare',
  components: {
    ElDialog: Dialog,
    QR,
    commentTextarea,
    MessageDialog,
  },
  inject: {
    PostItemData: {
      value: 'PostItemData',
      default: null,
    },
  },
  props: {
    refId: {
      type: Number,
      default: null,
    },
    shareObj: {
      // 分享链接
      type: Object,
      default() {
        return {
          url: null,
          title: null,
          content: null,
          pic: null,
          pictureUrls: null,
          authorId: null,
          authorNick: null,
          weiboshare: null,
        };
      },
    },
    numObj: {
      // 数字相关
      type: Object,
      default() {
        return {
          likeCount: 0,
          commentCount: 0,
          like: false,
        };
      },
    },
    type: {
      // 文章类型
      type: String,
      default: null,
    },
    layout: {
      // 点赞布局类型
      type: String,
      default: 'share,like,comment',
    },
    reviewStatus: {
      // reviewStatus是否审核通过，审核失败不能评论或者分享 approved:审核通过 rejected:审核不通过 pending:暂未审核
      type: String,
      default: 'approved',
    },
    defaultContent: {
      // 输入框默认内容
      type: String,
      default: '',
    },
    autoFocus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkPage,
      showDialog: false,
      showMomentListDialog: false,
      showMomentShareDialog: false,
      messageData: {
        show: false,
        content: '',
      },
      shareableMoments: [],
      selectedMoment: null,
      submitMomentInfo: {},
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'momentPublishable']),
    qrUrl() {
      // 获取配置文件的域名
      const prefix = this.$config.MSite;
      return encodeURI(new URL(this.shareObj.url, prefix).href);
    },
    weboUrl() {
      let url;
      if (this.shareObj.weiboshare) {
        url = this.shareObj.weiboshare;
      } else {
        url = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
          this.qrUrl
        )}`;
        if (this.shareObj.title || this.shareObj.content) {
          url = `${url}&title=${encodeURIComponent(
            this.shareObj.title || this.shareObj.content
          )}`;
        }
        if (this.shareObj.pic) {
          url = `${url}&pic=${encodeURIComponent(this.shareObj.pic)}`;
        }
      }
      return url;
    },
    /**
     * @description 展示布局
     */
    layoutArr() {
      return this.layout.split(',');
    },
    // 是否首席圈动态  如果是 就不能分享到内部的渠道，比如 自己的首席圈 和 内部渠道
    isFromMoment() {
      return !!this.PostItemData?.moment;
    },
  },
  methods: {
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
    }),
    /**
     * @description 发送动态
     */
    async sendDynamicHandle(data) {
      const { url, title, content, pictureUrls, authorId, authorNick } =
        data.shareObj;
      const res = await this.$axios(
        sendDynamic({
          momentTags: data.momentTags, // 添加圈子分享参数
          momentId: data.momentId, // 圈子ID
          pictureUrls: data.pictureUrls, // 图片
          topicId: data.topic.topicId,
          content: data.content,
          sharedThingsRequest: {
            url,
            title,
            content,
            pictureUrls,
            authorId,
            authorNick,
          },
          refContents: data.refContents,
        })
      );
      if (res.statusCode === 200) {
        const href = res?.result?.route;
        if (href) {
          window.location.href = formartRoute(href);
        }
        this.showMomentListDialog = false;
        this.showMomentShareDialog = false;
        this.messageData.content = '已发布<br>内容审核中';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
    },
    closeMessage() {
      this.messageData.show = false;
      this.showDialog = false;
    },
    dialogCannel() {
      this.dialog.visible = false;
    },
    /**
     * @description 点击分享按钮
     */
    async handleShare(type) {
      if (!this.type === 'live') {
        const data = await this.$axios(
          shareItem({
            source:
              this.type === 'activity'
                ? 'dynamic'
                : this.type === 'article'
                ? 'article'
                : null,
            refId: this.refId,
          })
        );
        if (data.statusCode === 200) {
          this.numObj.shareCount++;
        }
      }
      if (this.reviewStatus !== 'approved') {
        this.messageData = {
          show: true,
          content: '内容正在审核中',
        };
        return false;
      }
      switch (type) {
        case 'weixin':
          this.dialog.visible = true;
          break;
        case 'weibo':
          this.linkPage(this.weboUrl);
          break;
        case 'guru':
          if (!this.isLogin) {
            this.show(false);
          } else {
            this.showDialog = true;
          }
          break;
        case 'moments':
          if (!this.isLogin) {
            this.show(false);
          } else {
            // 弹出选择框
            this.SwitchShareMomentList(true);
          }

          break;
        default:
          break;
      }
    },
    /**
     * @description 点击评论按钮
     */
    handleComment() {
      if (this.reviewStatus !== 'approved') {
        this.messageData = {
          show: true,
          content: '内容正在审核中',
        };
        return false;
      }
      this.$emit('clickComment');
    },
    /**
     * @description 点赞按钮
     */
    async handleLike(e) {
      if (!this.isLogin) {
        this.show(false);
        return false;
      }
      const type = this.type;
      let data = null;

      switch (type) {
        case 'activity':
          if (this.numObj.like) {
            data = await this.$axios(
              deleteDynamicLike({
                model: 1,
                type: 1,
                id: this.refId,
              })
            );
          } else {
            data = await this.$axios(
              setDynamicLike({
                model: 1,
                type: 1,
                id: this.refId,
              })
            );
          }
          break;
        case 'article':
          if (this.numObj.like) {
            data = await this.$axios(
              cancelLikePost({
                postId: this.refId,
              })
            );
          } else {
            data = await this.$axios(
              likePost({
                postId: this.refId,
              })
            );
          }
          break;
        case 'comment':
          if (this.numObj.like) {
            data = await this.$axios(deleteCommentLike(this.refId));
          } else {
            data = await this.$axios(setCommentLike(this.refId));
          }
          break;
        default:
          break;
      }
      if (data.statusCode === 200) {
        this.$emit('likeChange', e);
      }
    },
    // 获取首席圈分享列表
    async InitShareAbleMomentList() {
      const [, data] = await this.$http(GetShareAbleMoments());
      const r = data?.result || [];
      this.shareableMoments = r;
      if (r.length === 0) return false;
      return true;
    },
    // 确认分享内容首席圈
    ConfirmShareToMoment() {
      this.showMomentShareDialog = true;
      this.showMomentListDialog = false;
      this.submitMomentInfo = this.selectedMoment;
    },
    // 开启 or 关闭首席圈
    async SwitchShareMomentList(type) {
      let r;
      switch (type) {
        case false:
          this.showMomentListDialog = false;
          this.selectedMoment = null;
          break;
        case true:
          this.selectedMoment = null;
          this.submitMomentInfo = null;
          r = await this.InitShareAbleMomentList();
          if (r === true) {
            this.showMomentListDialog = true;
          } else {
            this.$messagebox.show(
              { title: '系统错误', describe: '无可用的首席圈' },
              { cb: () => {}, buttonName: ['确定'] }
            );
          }
          break;
        default:
          break;
      }
    },
  },
};
